import { Stack } from '@mui/material';
import React, { ReactNode } from 'react';

const ButtonStack = ({ children, wrap = false }:{ children: ReactNode; wrap?: boolean }) => (
  <Stack
    direction="row"
    spacing={wrap ? 0 : 2}
    justifyContent="right"
    alignItems="center"
    sx={{
      padding: 1,
      textAlign: 'center',
      height: '64px',
      boxShadow: '0 -5px 3px -3px #00000030',
      ...(wrap ? { height: 'auto', minHeight: 64, flexShrink: 0, flexWrap: 'wrap', gap: 2, '& > .MuiButton-root': { height: 'auto', minHeight: 48 } } : {}),
    }}
  >
    {children}
  </Stack>
);

export default ButtonStack;
